<ng-select
  [ngClass]="{'disable-arrow': disableArrow, 'truncate-labels': truncateLabels, 'hide-close-item': !showClearItem, 'loading': loading, 'ng-select-sm': size === ACE_SELECT_SIZE.SM}"
  #ngselect
  [clearAllText]="'Clear' | messageTranslate"
  [multiple]="multiSelect"
  [items]="loading && !showItemsWhileLoading ? [] : items // When loading do not display any items, as they will soon be replaced, and if actually selected by the user, can lead to unwanted behaviour. For some reason ng-select does not do this be default"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [loading]="loading"
  [searchable]="true"
  [hideSelected]="hideSelected"
  [groupBy]="groupBy"
  [selectableGroup]="selectableGroup"
  [selectableGroupAsModel]="selectableGroupAsModel"
  [appendTo]="appendTo"
  [searchFn]="searchFn"
  [readonly]="isReadOnly"
  [clearable]="clearable"
  [closeOnSelect]="closeOnSelect"
  [compareWith]="compareWith"
  [groupValue]="groupValue"
  [typeahead]="typeahead"
  [virtualScroll]="virtualScroll"
  (add)="onAdd($event)"
  (remove)="onRemove($event)"
  (clear)="onClear()"
  (focus)="onNgSelectOnFocus($event)"
  (paste)="pasteEnabled ? onPaste($event) : undefined"
  (open)="onOpen()"
  (close)="onClose()"
  (scroll)="onScroll()"
  (scrollToEnd)="onScrollToEnd()">

  @if (showAddTag && !showPasteTemplate && ngselect?.searchTerm?.length) {
    <ng-template ng-header-tmp let-item="item" let-clear="clear" let-searchTerm="searchTerm">
      @if (searchTerm?.length && isAddedTagValid(searchTerm)) {
        <span (click)="addItem(searchTerm)" class="clickable">
          <span class="add-item-text">{{ addTagText | messageTranslate }} </span>"{{ searchTerm }}"
        </span>
      }
      @if (!isAddedTagValid(searchTerm)) {
        <span class="invalid-feedback d-flex">
          {{ addTagValidateMessage | messageTranslate }}
        </span>
      }
    </ng-template>
  }

  @if (showPasteTemplate) {
    <ng-template ng-header-tmp let-item="item" let-clear="clear">
      @if (itemsToAdd?.length) {
        <span (click)="addItems()" class="clickable">
          <span class="add-item-text">{{ itemsToAdd.length > 1 ? 'Add items' : 'Add item' | messageTranslate }} </span>"{{ itemsToAdd.join(', ') }}"
        </span>
      }
    </ng-template>
  }

  @if (!multiSelect && labelTemplate) {
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <ng-container *ngTemplateOutlet="labelTemplate; context:{item: item, clear: clear}"/>
    </ng-template>
  }

  <!-- ng-select evaluates templates e.g. ng-multi-label-tmp in order and uses the first one whose @if condition is true.
  So, order matters - put more specific conditions (like loading state) before general ones -->
  @if (multiSelect && multiLabelTemplate) {
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <ng-container *ngTemplateOutlet="multiLabelTemplate; context:{items: items, clear: clear}"/>
    </ng-template>
  }

  @if (hideValueLabelsWhileLoading && loading) {
    <ng-template ng-multi-label-tmp>
      <div class="text-body-secondary font-italic mx-1 mb-1">{{ 'Loading...' | messageTranslate }}</div>
    </ng-template>
  }

  <!--  testing against ngselect?.selectedItems?.length, instead of items.length as changes to items do not trigger change detection -->
  @if (multiSelect && maxSelectedLabels != null && (ngselect?.selectedItems?.length > maxSelectedLabels)) {
    <ng-template ng-multi-label-tmp let-items="items">
      <ng-template #aggregatedTooltipContent>
        <ul class="text-start list-unstyled p-0">
          <!-- TODO: KQ: improve track property -->
          @for (item of ngselect.selectedItems; track item) {
            <li>
              &bull; {{getToolTip(item)}}
            </li>
          }
        </ul>
      </ng-template>
      <div class="ng-value">
        <span class="ng-value-label" [ngbTooltip]="aggregatedTooltipContent" container="body">
          {{ (maxSelectedShowItemName ? '(n) (items) selected' : '(n) selected') | messageTranslate:{
            n: items.length,
            items: maxSelectedItemName ? (maxSelectedItemName | messageTranslate) : (placeholder || '')
          } }}
        </span>
      </div>
    </ng-template>
  }

  <!--  Handles custom ng-multi-label-tmp when using custom tooltips but not collapsing because of maxSelectedLabels (ng-template above)-->
  @if (multiSelect && customItemTooltip != null) {
    <ng-template ng-multi-label-tmp let-clear="clear">
      <!-- TODO: KQ: improve track property -->
      @for (item of ngselect?.selectedItems; track item) {
        <div class="ng-value">
          @let toolTip = getToolTip(item);
          <span class="ng-value-icon left" (click)="clear(item.value)">&times;</span>
          <span class="ng-value-label"
                container="body"
                [ngbTooltip]="toolTip">{{item?.label}}</span>
        </div>
      }
    </ng-template>
  }

  @if (optionTemplate) {
    <ng-template ng-option-tmp let-item="item">
      <ng-container *ngTemplateOutlet="optionTemplate; context:{item: item}"/>
    </ng-template>
  }

  @if (groupOptionTemplate) {
    <ng-template ng-optgroup-tmp let-item="item">
      <ng-container *ngTemplateOutlet="groupOptionTemplate; context:{item: item}"/>
    </ng-template>
  }

</ng-select>
